import {
  Avatar,
  Button,
  Grid,
  LinearProgress,
  linearProgressClasses,
  MenuItem,
  Select,
  Typography,
  useMediaQuery,
  Dialog,
  Box,
} from '@mui/material';

import styled from '@emotion/styled';
import { Stack } from '@mui/system';
import { ReactComponent as Call } from 'assets/icons/call.svg';
import { ReactComponent as Message } from 'assets/icons/Chat.svg';
import { ReactComponent as Paper } from 'assets/icons/Paper.svg';
import { ReactComponent as ProfileRed } from 'assets/icons/profile_skel.svg';
import { highStarStyle } from 'component/BuyerRegistration/BuyerRegistration.style';
import CircularProgressBar from 'component/CircularProgressBar/CircularProgressBar';
import ContactPopOver from 'component/ContactTab/ContactPopOver';
import {
  HighStar,
  TrophyIcon,
} from 'modules/private/ViewDashBoardDetails/ViewDashboardDetails';
import { useContext, useState } from 'react';
import {
  displayFlexColumn,
  fontsize10,
  fontsize14,
  poppins400,
  poppins500,
} from 'theme/common.style';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useTheme } from '@mui/styles';
import { datacontext } from 'modules/AppLayout/AppLayout';
import {
  SOLICITOR_CREATE_BINDER,
  CREATE_BINDER_WITH_AGENT,
} from 'constant/app.config';
import { postApiCall } from 'api/apiService';
import Loading from 'assets/images/loading.png';

export const Hotspot = ({ color = '#666666' }) => {
  return (
    <svg
      width={20}
      height={15}
      viewBox="0 0 22 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.7779 0.189784C18.6476 0.0767684 18.4752 0.0152416 18.2971 0.0181661C18.119 0.0210906 17.9491 0.0882381 17.8231 0.205462C17.6971 0.322686 17.625 0.480834 17.6218 0.646588C17.6187 0.812342 17.6848 0.97276 17.8062 1.09405C18.7014 1.92489 19.4113 2.91222 19.895 3.99925C20.3788 5.08628 20.6268 6.25158 20.625 7.42815C20.625 9.90207 19.5488 12.1397 17.8062 13.7614C17.6809 13.882 17.6116 14.0436 17.6131 14.2114C17.6145 14.3791 17.6868 14.5396 17.8142 14.6583C17.9416 14.777 18.114 14.8443 18.2942 14.8459C18.4745 14.8474 18.6482 14.783 18.7779 14.6665C19.8008 13.717 20.612 12.5887 21.1649 11.3465C21.7179 10.1043 22.0017 8.7727 22 7.42815C22 4.60105 20.768 2.04096 18.7779 0.189784ZM4.19375 1.09405C4.31519 0.97276 4.38131 0.812342 4.37816 0.646588C4.37502 0.480834 4.30287 0.322686 4.17691 0.205462C4.05095 0.0882381 3.88101 0.0210906 3.7029 0.0181661C3.52479 0.0152416 3.35242 0.0767684 3.22209 0.189784C2.19921 1.13934 1.388 2.26762 0.83505 3.5098C0.282105 4.75199 -0.00167578 6.0836 7.44418e-06 7.42815C7.44418e-06 10.2544 1.23201 12.8145 3.22209 14.6665C3.35242 14.7795 3.52479 14.8411 3.7029 14.8381C3.88101 14.8352 4.05095 14.7681 4.17691 14.6508C4.30287 14.5336 4.37502 14.3755 4.37816 14.2097C4.38131 14.044 4.31519 13.8835 4.19375 13.7623C3.29859 12.9314 2.58873 11.9441 2.10499 10.857C1.62124 9.77001 1.37316 8.60471 1.37501 7.42815C1.37501 4.95422 2.45117 2.71575 4.19375 1.09405ZM7.43417 4.10968C7.55561 3.98839 7.62172 3.82797 7.61858 3.66222C7.61544 3.49646 7.54328 3.33832 7.41732 3.22109C7.29136 3.10387 7.12142 3.03672 6.94332 3.0338C6.76521 3.03087 6.59283 3.0924 6.4625 3.20541C5.86586 3.75941 5.39271 4.41764 5.07023 5.14231C4.74774 5.86697 4.58228 6.6438 4.58334 7.42815C4.58228 8.2125 4.74774 8.98932 5.07023 9.71399C5.39271 10.4387 5.86586 11.0969 6.4625 11.6509C6.59223 11.7674 6.76592 11.8318 6.94618 11.8303C7.12644 11.8287 7.29884 11.7614 7.42625 11.6427C7.55366 11.524 7.62588 11.3635 7.62736 11.1957C7.62884 11.028 7.55946 10.8664 7.43417 10.7458C6.96525 10.3105 6.59344 9.79321 6.34016 9.22369C6.08688 8.65417 5.95712 8.04366 5.95834 7.4273C5.95736 6.81122 6.08724 6.20103 6.34051 5.63182C6.59379 5.06261 6.96546 4.54476 7.43417 4.10968ZM15.5375 3.20541C15.4746 3.14255 15.3987 3.09213 15.3143 3.05717C15.23 3.0222 15.139 3.00339 15.0466 3.00188C14.9543 3.00036 14.8626 3.01616 14.777 3.04834C14.6914 3.08052 14.6137 3.12842 14.5484 3.18917C14.4831 3.24993 14.4316 3.3223 14.3971 3.40197C14.3625 3.48163 14.3455 3.56697 14.3471 3.65287C14.3488 3.73878 14.369 3.8235 14.4065 3.90198C14.4441 3.98047 14.4983 4.0511 14.5658 4.10968C15.0348 4.54496 15.4066 5.06224 15.6598 5.63176C15.9131 6.20127 16.0429 6.81178 16.0417 7.42815C16.0428 8.04437 15.9129 8.65472 15.6597 9.22408C15.4064 9.79345 15.0346 10.3106 14.5658 10.7458C14.4983 10.8043 14.4441 10.875 14.4065 10.9535C14.369 11.0319 14.3488 11.1167 14.3471 11.2026C14.3455 11.2885 14.3625 11.3738 14.3971 11.4535C14.4316 11.5331 14.4831 11.6055 14.5484 11.6663C14.6137 11.727 14.6914 11.7749 14.777 11.8071C14.8626 11.8393 14.9543 11.8551 15.0466 11.8536C15.139 11.8521 15.23 11.8333 15.3143 11.7983C15.3987 11.7633 15.4746 11.7129 15.5375 11.65C16.134 11.0961 16.6071 10.438 16.9296 9.71353C17.2521 8.98902 17.4176 8.21236 17.4167 7.42815C17.4176 6.64394 17.2521 5.86728 16.9296 5.14277C16.6071 4.41825 16.134 3.7593 15.5375 3.20541ZM12.8333 7.42815C12.8335 7.76815 12.7245 8.10044 12.5204 8.38239C12.3162 8.66435 12.0262 8.88311 11.6875 9.01061V16.1722C11.6875 16.3419 11.6151 16.5046 11.4861 16.6246C11.3572 16.7446 11.1823 16.812 11 16.812C10.8177 16.812 10.6428 16.7446 10.5139 16.6246C10.3849 16.5046 10.3125 16.3419 10.3125 16.1722V9.01061C10.0042 8.89453 9.73557 8.70259 9.53549 8.45533C9.33541 8.20806 9.21137 7.91481 9.17667 7.60696C9.14197 7.29912 9.19791 6.98829 9.3385 6.70777C9.4791 6.42725 9.69904 6.18761 9.97478 6.01452C10.2505 5.84142 10.5717 5.7414 10.9038 5.72516C11.2359 5.70891 11.5666 5.77707 11.8603 5.92231C12.154 6.06756 12.3997 6.28443 12.5711 6.54969C12.7425 6.81496 12.8332 7.11862 12.8333 7.42815Z"
        fill="#666666"
      />
    </svg>
  );
};

export const Calldownarrow = () => {
  return (
    <svg
      width="9"
      height="9"
      viewBox="0 0 9 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.44887 7.77981C3.40779 7.73979 3.23213 7.58867 3.08763 7.4479C2.17883 6.6226 0.691333 4.46966 0.237292 3.34281C0.164333 3.17168 0.00991667 2.73902 0 2.50785C0 2.28635 0.051 2.07519 0.154417 1.8737C0.298917 1.62252 0.526292 1.42103 0.79475 1.31062C0.981042 1.23955 1.5385 1.12914 1.54842 1.12914C2.15829 1.01873 3.14925 0.958008 4.24433 0.958008C5.28771 0.958008 6.23829 1.01873 6.85737 1.10913C6.86729 1.11948 7.56004 1.22989 7.79733 1.35064C8.23083 1.57215 8.5 2.00481 8.5 2.46783V2.50785C8.48938 2.8094 8.22021 3.44356 8.21029 3.44356C7.75554 4.50968 6.341 6.61294 5.40104 7.45825C5.40104 7.45825 5.1595 7.69632 5.00863 7.79983C4.79187 7.9613 4.52342 8.04134 4.25496 8.04134C3.95533 8.04134 3.67625 7.95095 3.44887 7.77981Z"
        fill="#666666"
      />
    </svg>
  );
};

export const ValueForming = ({ data }) => (
  <Typography sx={{ ...poppins400, fontSize: '14px', marginRight: '10px' }}>
    FHB
  </Typography>
);

export const Contact = ({
  row,
  directcomm,
  moxouserId,
  openFeedback,
  setOpenFeedback,
  setBuyerCardOpen,
  buyerCardOpen,
  ExpandedBuyerRegister,
  propertyDetails,
  userDetail,
  fromSavedSearch = false,
  onShowChat,
  refreshSavedSearch,
}) => {
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const history = useHistory();
  const { setShowMessage, setMessagedata } = useContext(datacontext);
  const [requestBinderPopup, setRequestBinderPopup] = useState(false);
  const [loadingRequest, setLoadingRequest] = useState(false);

  const messageId = ExpandedBuyerRegister
    ? row?.solicitorDetails?.binderId
    : fromSavedSearch
    ? row?.agentDetails?.agentId
    : !moxouserId
    ? row?.user?.userId
    : row?.buyerContact?.binderId;

  const contactMobile = ExpandedBuyerRegister
    ? row?.solicitorDetails?.bsMobile
    : fromSavedSearch
    ? row?.agentDetails?.agentMobileNo
    : moxouserId
    ? row?.buyerContact?.buyerPhone
    : row?.userMobile;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setDialogOpen(true);
  };

  const handleMouseLeave = () => {
    setTimeout(() => {
      setIsHovered(false);
    }, 1500);
  };

  const handleRequestBinderDialogCancel = () => {
    setRequestBinderPopup(false);
  };

  const handleRequestedBuyerBinder = () => {
    setLoadingRequest(true);

    if (fromSavedSearch) {
      const userDetail = JSON.parse(localStorage.getItem('userDetail'));

      const data = {
        agentId: row?.agentDetails?.agentId,
        propertyId: row?.property?.propertyId,
        buyerId: userDetail?.userId,
        userEmail: userDetail?.userEmail,
        agentEmail: row?.agentDetails?.agentEmail,
      };

      postApiCall(CREATE_BINDER_WITH_AGENT, data)
        .then((res) => {
          const binderId = res?.data?.binderId ?? row?.agentDetails?.binderId;
          refreshSavedSearch?.();
          if (binderId) {
            onShowChat(binderId);
          }

          setLoadingRequest(false);
          setRequestBinderPopup(false);
        })
        .catch(() => {
          setLoadingRequest(false);
        });

      return;
    }

    const data = {
      solicitorId: row?.solicitorDetails?.bsId,
      propertyId: propertyDetails?.PropertyDetails?.property?.propertyId,
      userId: userDetail?.userId,
      userEmail: userDetail?.userEmail,
      isUserAgent: 1,
      solicitorEmail: row?.solicitorDetails?.bsEmail,
      isBuying: 1,
    };

    postApiCall(SOLICITOR_CREATE_BINDER, data)
      .then((res) => {
        const binderId = res?.data?.binderId;

        if (binderId) {
          if (ExpandedBuyerRegister) {
            onShowChat(binderId);
          } else {
            directcomm(binderId);
          }
        }

        setLoadingRequest(false);
        setRequestBinderPopup(false);
      })
      .catch(() => {
        setLoadingRequest(false);
      });
  };

  return (
    <>
      <Stack direction={'row'}>
        <Avatar
          variant="rounded"
          style={{
            border: '1px solid rgba(0, 0, 0, 0.12)',
            background: 'white',
            marginRight: '5px',
            height: '30px',
            width: '30px',
            cursor: 'pointer',
          }}
          onClick={() => {
            if (openFeedback || buyerCardOpen) {
              if (directcomm) {
                directcomm(messageId);
              }
              return;
            }
            if (ExpandedBuyerRegister) {
              const binderId = row?.solicitorDetails?.binderId;

              if (binderId) {
                onShowChat(binderId);
                return;
              }

              setRequestBinderPopup(true);
              return;
            }
            if (fromSavedSearch) {
              const binderId = row?.agentDetails?.binderId;

              if (!binderId) {
                setRequestBinderPopup(true);
                return;
              }
              onShowChat(binderId);
              // directcomm(messageId, row?.property?.propertyId);
              return;
            }

            directcomm(messageId);
          }}
        >
          <Message height={16} width={16} />
        </Avatar>
        <Avatar
          variant="rounded"
          style={{
            border: '1px solid rgba(0, 0, 0, 0.12)',
            background: 'white',
            cursor: 'pointer',
            height: '30px',
            width: '30px',
            marginLeft: '5px',
          }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={handleMouseLeave}
          onClick={() => {
            // localStorage.setItem(
            //   'dialId',
            //   ExpandedBuyerRegister
            //     ? row?.solicitorDetails?.bsEmail
            //     : row?.userEmail
            // );
            // setShowMessage(true);
            // setMessagedata({ incomingcall: true });
            return window.open(`tel:${contactMobile}`);
          }}
        >
          <Call height={16} width={16} />
        </Avatar>
        {/* &nbsp;&nbsp;
        <Grid
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: '3px',
            cursor: 'pointer',
          }}
          onClick={handleClick}
        >
          {isHovered && <Calldownarrow />}
        </Grid>
        <ContactPopOver
          name={
            ExpandedBuyerRegister
              ? row?.solicitorDetails?.bsName
              : moxouserId
              ? row?.buyerDetails?.buyerName
              : row?.user?.userName
          }
          surname={
            ExpandedBuyerRegister
              ? row?.solicitorDetails?.bsSurname
              : moxouserId
              ? row?.buyerDetails?.buyerSurName
              : row?.user?.userSurName
          }
          emailid={
            ExpandedBuyerRegister
              ? row?.solicitorDetails?.bsEmail
              : moxouserId
              ? row?.buyerContact?.buyerEmail
              : row?.userEmail
          }
          mobilenum={
            ExpandedBuyerRegister
              ? row?.solicitorDetails?.bsMobile
              : moxouserId
              ? row?.buyerContact?.buyerPhone
              : row?.userMobile
          }
          isDialogOpen={isDialogOpen}
          setDialogOpen={setDialogOpen}
          anchorEl={anchorEl}
          setAnchorEl={setAnchorEl}
        /> */}
      </Stack>
      <Dialog
        open={requestBinderPopup}
        onClose={handleRequestBinderDialogCancel}
        BackdropProps={{
          sx: {
            backgroundColor: 'rgba(0,0,0,0.3)',
          },
        }}
        PaperProps={{
          sx: {
            borderRadius: '12px',
            padding: '24px 28px',
            width: '420px',
            maxWidth: '90%',
            boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.15)',
          },
        }}
      >
        <Box display="flex" flexDirection="column" gap={2}>
          <Typography
            sx={{
              fontFamily: 'Poppins',
              fontWeight: 600,
              fontSize: '20px',
              color: '#000',
            }}
          >
            Binder not available
          </Typography>

          <Typography
            sx={{
              fontFamily: 'Poppins',
              fontWeight: 400,
              fontSize: '14px',
              color: '#666',
              lineHeight: '20px',
            }}
          >
            Do you want to create a binder with{' '}
            {fromSavedSearch
              ? `${row?.agentDetails?.agentName} ${row?.agentDetails?.agentSurName}`
              : `${row?.solicitorDetails?.bsName} ${row?.solicitorDetails?.bsSurname}`}
            ?
          </Typography>

          <Box
            display="flex"
            justifyContent="flex-end"
            gap={2}
            mt={2}
            alignItems="center"
          >
            <Button
              variant="outlined"
              onClick={handleRequestBinderDialogCancel}
              disabled={loadingRequest}
              sx={{
                textTransform: 'none',
                fontFamily: 'Poppins',
                fontSize: '14px',
                color: '#666',
                borderColor: '#E0E0E0',
                padding: '6px 20px',
                borderRadius: '6px',
              }}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              onClick={handleRequestedBuyerBinder}
              disabled={loadingRequest}
              sx={{
                textTransform: 'none',
                fontFamily: 'Poppins',
                fontSize: '14px',
                backgroundColor: '#4CA4D6',
                padding: '6px 20px',
                borderRadius: '6px',
                '&:hover': {
                  backgroundColor: '#3b8fc0',
                },
              }}
            >
              Confirm
            </Button>

            {loadingRequest && (
              <img
                src={Loading}
                alt="loading"
                className="loaderImage"
                style={{ height: 32, width: 32 }}
              />
            )}
          </Box>
        </Box>
      </Dialog>
    </>
  );
};

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: '16px',
  borderRadius: 3,
  border: '1px solid #6C2AD2',
  [`&.${linearProgressClasses.colorPrimary}`]: {
    background: 'white',
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 0,
    background: `linear-gradient(140.46deg, #6C2AD2 -27.13%, #77CFFE 121.57%)`,
  },
}));

export const ProgressData = ({ row }) => (
  <Typography sx={{ width: '50px', position: 'relative' }}>
    <BorderLinearProgress value={row} variant="determinate" />
    <Typography
      sx={{
        color: 'white',
        position: 'absolute',
        top: '5%',
        left: '30%',
        fontSize: '10px',
        fontWeight: 400,
      }}
      variant="caption"
    >
      {row}%
    </Typography>
  </Typography>
);

export const OfferContainer = ({
  color,
  row,
  data,
  agentReg,
  offerIsFinal,
  userTypeValue,
  isMarket,
  propertyDetails,
  index,
  pendingTable,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isShareHovered, setIsShareHovered] = useState(false);
  const containerStyle = {
    position: 'relative',
    display: 'inline-block',
    height: '10px',
  };

  const containerShareStyle = {
    position: 'relative',
    display: 'inline-block',
    marginTop: '6px',
  };

  const textStyle = {
    visibility: 'hidden',
    backgroundColor: '#fff',
    color: '#000',
    textAlign: 'center',
    borderRadius: '6px',
    padding: '5px 10px',
    position: 'absolute',
    zIndex: 1,
    bottom: '125%',
    left: '50%',
    transform: 'translateX(-50%)',
    whiteSpace: 'nowrap',
    boxShadow: '8px 8px 8px 8px rgba(0, 0, 0, 0.1)',
    fontFamily: 'Poppins',
    fontSize: '10px',
  };

  const textVisibleStyle = {
    ...textStyle,
    visibility: 'visible',
    opacity: 1,
    transition: 'opacity 0.3s',
  };
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));

  const firstStageTwoBuyer = propertyDetails?.BuyerRegisterDetails?.find(
    (item) => item?.isStageTwo === 1
  );
  const firstStageTwoBuyerId = firstStageTwoBuyer?.buyerDetails?.user?.userId;
  const currentBuyerId = row?.buyerDetails?.user?.userId;

  const userType = JSON.parse(localStorage.getItem('userType'))?.userType;

  const showBestFinal =
    (offerIsFinal == 1 && userTypeValue === 'Agent') ||
    (offerIsFinal == 1 &&
      propertyDetails?.PropertyDetails?.highestOfferIsFinal === 1 &&
      userType === 'Vendor');

  return (
    <Typography sx={displayFlexColumn}>
      <Stack sx={{ display: 'flex', flexDirection: 'row', gap: '5px' }}>
        {showBestFinal && (
          <div
            style={containerStyle}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <HighStar style={highStarStyle} />
            <span style={isHovered ? textVisibleStyle : textStyle}>
              Best & Final Offer
            </span>
          </div>
        )}
        <Typography
          sx={{
            ...poppins400,
            fontSize: matchessm ? '10px' : '14px',
            textAlign: agentReg ? 'left' : 'center',
          }}
        >
          {data ? data : '-'}
        </Typography>
      </Stack>

      {!pendingTable &&
      propertyDetails?.PropertyDetails?.stage == 'ST2' &&
      propertyDetails?.PropertyDetails?.timerStatus == 'End' &&
      propertyDetails?.PropertyDetails?.isWinner == 0 &&
      currentBuyerId &&
      currentBuyerId === firstStageTwoBuyerId ? (
        <Typography
          sx={{
            borderRadius: '54px',

            width: '120px',
            padding: '2px 14px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '5px',

            border: '1px solid ',
            borderColor: '#AF52DE',
          }}
        >
          <Typography sx={{ display: 'flex' }}>
            <TrophyIcon color="#AF52DE" />
          </Typography>
          <Typography
            whiteSpace={'nowrap'}
            sx={{
              fontFamily: 'poppins',
              fontWeight: 500,
              fontSize: '12px',
              color: '#AF52DE',
              display: 'flex',
            }}
          >
            Processing
          </Typography>
        </Typography>
      ) : (
        <Stack
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: '5px',
          }}
        >
          {isMarket == 1 && userTypeValue == 'Agent' && (
            <div
              style={{
                position: 'relative',
                display: 'inline-block',
                marginTop: '10px',
                marginRight: '6px',
              }}
              onMouseEnter={() => setIsShareHovered(true)}
              onMouseLeave={() => setIsShareHovered(false)}
            >
              <Hotspot />
              <span style={isShareHovered ? textVisibleStyle : textStyle}>
                Shared to Market
              </span>
            </div>
          )}
          {data && (
            <Typography
              sx={{ ...poppins500, ...fontsize10 }}
              style={{
                background:
                  row?.buyerOfferDetails?.isWinner == 1
                    ? 'rgba(108, 42, 210, 1)'
                    : row?.buyerOfferDetails?.logIsConditional === 1
                    ? 'rgba(237, 11, 11, 0.6)'
                    : 'rgba(16, 211, 94, 1)',
                boder: '1px solid red',
                borderRadius: '5px',
                color: 'white',
                padding: '4px 8px',
                height: '22px',
              }}
            >
              {row?.buyerOfferDetails?.isWinner == 1
                ? 'Winner'
                : row?.buyerOfferDetails?.logIsConditional == 1
                ? 'Conditional'
                : ' Unconditional'}
            </Typography>
          )}
        </Stack>
      )}
    </Typography>
  );
};

export const StatusCardData = () => (
  <Typography sx={displayFlexColumn}>
    <Typography>
      <Paper />
    </Typography>
    <Typography sx={{ ...poppins400, ...fontsize10 }}>s66W</Typography>
  </Typography>
);

export const ExpCardData = ({ color, value }) => (
  <Stack
    direction={'row'}
    spacing={1}
    alignItems={'center'}
    justifyContent={'center'}
  >
    <ProfileRed height={20} width={20} color="green" />
    <Avatar
      sx={{ bgcolor: 'red', ...poppins400, ...fontsize10 }}
      alt="Remy Sharp"
      style={{
        height: '25px',
        width: '25px',
        color: 'white',
      }}
    >
      {value}
    </Avatar>
  </Stack>
);

export const ProgressWithCircle = ({ row }) => {
  return <CircularProgressBar value={row} row={row} />;
};

export const ActionContainer = (progress) => (
  <Stack direction={'row'} spacing={1}>
    <Button
      sx={{
        ...poppins400,
        boxShadow: 'none',
        '.MuiOutlinedInput-notchedOutline': { border: 0 },
        fontSize: '14px',
        color: '#6C2AD2',
        bgcolor: 'rgba(108, 42, 210, 0.1)',
      }}
    >
      Feedback
    </Button>
    <Select
      sx={{
        ...poppins500,
        fontSize: '12px',
        color: '#6C2AD2',
        border: 'none',
        borderRadius: '4px',
        border: '1px solid #6C2AD2',
      }}
      size="small"
      value="10"
      style={{
        padding: '0px 4px',
      }}
      onChange={() => {}}
      displayEmpty
      inputProps={{
        'aria-label': 'Without label',
        color: '1px solid #6C2AD2',
      }}
    >
      <MenuItem value={10}>Action</MenuItem>
      <MenuItem value={20}>Twenty</MenuItem>
      <MenuItem value={30}>Thirty</MenuItem>
    </Select>
  </Stack>
);
